
import { Vue, Component, Prop, PropSync, Watch } from "vue-property-decorator";
import { Action } from "vuex-class";
import { getFormatDate } from "@/common/utils";
import config from "@/config";
import { pageViewUnit } from "@/config";
@Component({
  name: "Policy",
  components: {},
})
export default class Policy extends Vue {
  @Action("policy/addReadView") private addReadView: any;
  @Action("policy/getImgDetail") private getPolicyData: any;
  pageViewUnit = pageViewUnit;
  pageData: any = {};
  imgId: any = this.$route.query.imgId;
  file: any = [];
  created() {
    const imgId = this.imgId;
    // this.addReadView(imgId);
    this.getData();
  }
  download({ url }: any) {
    window.open(url);
  }
  getData() {
    this.getPolicyData(this.imgId).then(({ code, result, msg }: any) => {
      if (code === 200) {
        let data = result;
        const { enclosureVoList } = data;
        data.releaseDate = getFormatDate(data.releaseDate);
        // data.year = data.pubDate.slice(0, 4);
        this.pageData = data;
        this.file = enclosureVoList.map(
          ({ enclosureName, enclosureUrl }: any) => {
            const name = enclosureName.split("-")[
              enclosureName.split("-").length - 1
            ];
            const baseURL =
              process.env.NODE_ENV === "development"
                ? config.basicUrl
                : `${location.origin}/`;
            const url = `${baseURL}zst/user/file/downloadFile?filePath=${encodeURIComponent(
              enclosureUrl
            )}`;
            return { name, url };
          }
        );
      }
      return data;
    });
  }
}
